/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Empty_PropertiesInputs */

const cs_templates_use_picker_empty_properties = /** @type {(inputs: Templates_Use_Picker_Empty_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné inzeráty. Nejdřív vytvořte nemovitost.`)
};

const en_templates_use_picker_empty_properties = /** @type {(inputs: Templates_Use_Picker_Empty_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listings yet. Create a property first.`)
};

/**
* | output |
* | --- |
* | "No listings yet. Create a property first." |
*
* @param {Templates_Use_Picker_Empty_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_empty_properties = /** @type {((inputs?: Templates_Use_Picker_Empty_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Empty_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_empty_properties(inputs)
	return cs_templates_use_picker_empty_properties(inputs)
});